import $http from "./http-index";

export const getDataAll = data => {
    return $http.post("/realData/getDataAll", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export const getNewestPower = data => {
    return $http.post("/collect/history/getNewestPower", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};


export const getWarnSwitch = data => {
    return $http.post("/realData/getWarnSwitch", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
